import { Box, FormGroup, Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ControlledCheckbox, RequiredAsterisk } from '@components';

export const FutureLoanPlans = () => {
  const { t } = useTranslation('subModules/futureLoanPlans');
  const fields: { [key: string]: string } = t('fields', {
    returnObjects: true,
  }) as { [key: string]: string };
  const { setValue, watch, trigger } = useFormContext();
  const values = watch('futureLoanPlans') || {};

  const handleCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    key: string
  ) => {
    const { checked } = event.target;

    if (key === 'none') {
      Object.keys(fields).forEach((fieldKey) => {
        setValue(
          `futureLoanPlans.${fieldKey}`,
          fieldKey === 'none' ? checked : false
        );
      });
    } else {
      setValue(`futureLoanPlans.${key}`, checked);

      if (values['none']) {
        setValue('futureLoanPlans.none', false);
      }
    }

    trigger('futureLoanPlans');
  };

  return (
    <Box
      id="futureLoanPlans"
      mb={3}
      data-testid="futureLoanPlansSubModule"
      data-tf-sensitive="true"
    >
      <Box mb={1}>
        <Typography variant="h6" component="h2">
          {t('label')}
          <RequiredAsterisk />
        </Typography>
      </Box>
      <FormGroup>
        <ControlledCheckbox
          name="futureLoanPlans"
          fields={fields}
          handleCheckboxChange={handleCheckboxChange}
        />
      </FormGroup>
    </Box>
  );
};
